export default () => {

const menuModals     = document.querySelectorAll('.mobile-menu-modal')
const mainMenuModals = document.querySelector('[data-menu-modal="main-mobile-menu"]')

const openHamburger  = document.querySelector('.hamburger-open')
const closeHamburger = document.querySelectorAll('.hamburger-close')
const backButton     = document.querySelectorAll('.back-button')

// const menutabactions = document.querySelectorAll('.menu-tab-action')
const allMenuModals = document.querySelectorAll('[data-modal]') // all menu with submenu
const allModals = document.querySelectorAll('[data-menu-modal]') // all modal window

//hasAttribute("data-modal")
const closeAllModals = () => {
   allModals.forEach(item=>{
      item.classList.remove('open')
   })
}

// Open Main Menu Modal
openHamburger.addEventListener('click',event=>{
   mainMenuModals.classList.add('open')
   document.body.classList.add('scroll-lock')
})

// Close all Modal Menu
closeHamburger.forEach(item=>{
   item.addEventListener('click',event=>{
      [].forEach.call(menuModals,function(el){
         el.classList.remove("open");
         document.body.classList.remove('scroll-lock')
      })
   })
})


// Submenu Buttons

allMenuModals.forEach(item=>{
   item.addEventListener('click',e=>{
      if(isMobile()){
         e.stopPropagation()
         e.preventDefault()
         closeAllModals();
         let target = item.dataset.modal
        
        document.querySelector(`[data-menu-modal="${target}"]`).classList.toggle('open')

      }

   })
})


// Back Button
backButton.forEach(item=>{
   item.addEventListener('click',e=>{
      e.stopPropagation()
      e.preventDefault()
      closeAllModals()
      let target = document.querySelector(`[data-menu-modal="${item.dataset.callbackModal}"]`)
      target.classList.toggle('open')
   })
})
}